<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  show: boolean;
}>();
</script>

<template>
  <Teleport to="body">
    <!-- Overlay Transition -->
    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="show"
        class="fixed inset-0 bg-black bg-opacity-50 z-[200]"
      ></div>
    </transition>
  </Teleport>
</template>
